import { useState } from 'react';


const useObjectState = defaultValue => {
    const [state, setState] = useState(defaultValue);

    const updateState = newState => {
        if (typeof newState === 'function') {
            setState(newState);
            return;
        }

        setState({ ...newState });
    };

    const deleteStateProperty = property => {
        const newState = { ...state };
        delete newState[property];
        setState(newState);
    }

    const updateStateProperty = properties => setState(oldState => ({ ...oldState, ...properties }));

    return [state, updateState, deleteStateProperty, updateStateProperty];
};

export default useObjectState;